<template>
  <div class="placeAnOrderBox">
    <div class="modelExhibition">
      <div class="title">
        <div class="titleLeft">3D文件展示</div>
        <div class="titleRight">
          <el-upload
            action="/service-center/upload/file/single"
            :on-success="handleAvatarSuccess"
            class="hiddenInput"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
          >
            <el-button type="text" icon="el-icon-upload2">模型上传</el-button>
          </el-upload>
          <el-button type="text" @click="historyUploadSelect"
            >历史上传</el-button
          >
        </div>
      </div>
      <div class="modelFileList">
        <div
          class="modelFileItem"
          v-for="(item, index) in modelFileList"
          :key="index"
          v-if="modelFileList.length > 0"
        >
          <div class="itemLeft">
            <!-- <model-stl :src="item.url"></model-stl> -->
            <model-stl ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'stl'" :src="item.url"></model-stl>
            <model-obj ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'obj'" :src="item.url"></model-obj>
            <div class="model" @click="previewThreeD(item)">
              <i class="el-icon-zoom-in"></i>
            </div>
          </div>
          <div class="itemRight">
            <div class="modelInfo">
              <div class="name">{{ item.name }}</div>
              <div class="size">
                <span>
                  模型尺寸：
                  <span v-if="!item.isEdit"
                    >{{ item.longSize }} * {{ item.widthSize }} *
                    {{ item.heightSize }}cm</span
                  >
                  <el-input
                    v-if="item.isEdit"
                    v-model="item.longSize"
                    placeholder="请输入长"
                    @blur="countModelInfo(item, 1)"
                    style="width: 100px"
                  ></el-input
                  ><span style="padding: 0" v-if="item.isEdit"> * </span>
                  <el-input
                    v-if="item.isEdit"
                    v-model="item.widthSize"
                    placeholder="请输入宽"
                    @blur="countModelInfo(item, 2)"
                    style="width: 100px"
                  ></el-input
                  ><span style="padding: 0" v-if="item.isEdit"> * </span>
                  <el-input
                    v-if="item.isEdit"
                    v-model="item.heightSize"
                    placeholder="请输入高"
                    @blur="countModelInfo(item, 3)"
                    style="width: 100px"
                  ></el-input>
                </span>
                <span>
                  体积：
                  <span v-if="!item.isEdit">{{ item.volume }}c㎥</span>
                  <el-input
                    v-if="item.isEdit"
                    v-model="item.volume"
                    disabled
                    style="width: 120px"
                  ></el-input>
                </span>
                <span>
                  缩放：
                  <span v-if="!item.isEdit">{{ item.scale }}%</span>
                  <el-input
                    v-if="item.isEdit"
                    v-model="item.scale"
                    placeholder="请输入内容"
                    @blur="countModelInfo(item, 4)"
                    style="width: 120px"
                  ></el-input>
                </span>
                <el-button
                  v-if="item.isEdit"
                  type="text"
                  @click="saveModelInfo(item)"
                  >保存</el-button
                >
              </div>
              <div class="operation">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="changeIsEdit(item)"
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="modelDelete(index)"
                ></el-button>
              </div>
            </div>
            <div class="modelCount">
              <div class="num">
                打印数量：
                <el-input-number
                  style="width: 120px"
                  v-model="item.printNum"
                  controls-position="right"
                  :min="1"
                ></el-input-number>
              </div>
              <div class="price">
                单价：
                <span>¥ {{ item.unitPrice }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modelFileItem"
          v-if="modelFileList.length <= 0"
          style="justify-content: center; font-size: 14px; color: #666666"
        >
          暂无模型文件，请点击上传模型按钮上传文件
        </div>
      </div>
    </div>
    <div class="typeInformation">
      <div class="title">
        <div class="titleLeft">打印信息</div>
      </div>
      <div class="typeInformationContent">
        <div class="facilitatorBox" v-if="facilitator&&facilitator.uuid">
          <div class="facilitatorBoxLeft" @click="getProviders(facilitator)">
            <div class="logo">
              <img :src="facilitator.storeLogo" alt="" />
            </div>
            <div class="info">
              <div class="name">{{ facilitator.storeName }}</div>
              <div class="location">
                <i class="el-icon-location"></i>
                <span>{{ facilitator.detailAddress }}</span>
              </div>
            </div>
          </div>
          <div
            class="facilitatorBoxRight"
            v-if="facilitator.managerList && facilitator.managerList.length > 0"
          >
            <div class="materials">
              {{ facilitator.managerList[0].materialName }}
            </div>
            <div class="price">
              价格：<span>{{ facilitator.managerList[0].unitPrice }}</span
              >元/克
            </div>
            <div class="deliveryTime">
              发货时间：{{ facilitator.managerList[0].sendCycleMin }}-{{
                facilitator.managerList[0].sendCycleMax
              }}天
            </div>
            <el-button type="text" @click="facilitatorEdit">编辑</el-button>
          </div>
        </div>
        <div
          class="facilitatorBox"
          v-else
          style="justify-content: center; font-size: 14px; color: #666"
        >
          <span
            @click="toSelectFacilitator"
            style="color: #1890ff; cursor: pointer"
            >请选择服务商</span
          >
        </div>
        <div class="information">
          <div class="informationItem">
            <div class="one-row">
              <div class="name">打印工艺：</div>
              <el-select
                v-model="technologyUuid"
                placeholder="选择工艺"
                @change="searchProvidersList"
              >
                <el-option
                  v-for="item in technologyList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="one-row">
              <div class="name">打印材料：</div>
              <el-cascader
                ref="materialsRef"
                v-model="materialUuid"
                :props="props"
                :options="materialList"
                placeholder="请选择材料"
                @change="searchProvidersList"
              ></el-cascader>
            </div>
            <div class="one-row">
              <div class="name">空心：</div>
              <el-checkbox v-model="soildUuid" @change="searchProvidersList"
                >是</el-checkbox
              >
            </div>
          </div>
          <div class="informationItem">
            <div class="one-row">
              <div class="name">后处理：</div>
              <el-switch v-model="isReprocess" @change="searchProvidersList">
              </el-switch>
            </div>
          </div>
          <div v-show="isReprocess">
            <div class="informationItem">
              <div class="one-row">
                <div class="name">类型：</div>
                <el-select
                  v-model="typeUuid"
                  @change="findSurfaceEffect"
                  placeholder="选择类型"
                >
                  <el-option
                    v-for="item in reprocessList"
                    :key="item.uuid"
                    :label="item.name"
                    :value="item.uuid"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="one-row">
                <div class="name">表面效果：</div>
                <el-select
                  v-model="surfaceEffectUuid"
                  placeholder="选择表面效果"
                >
                  <el-option
                    v-for="item in surfaceEffectList"
                    :key="item.uuid"
                    :label="item.name"
                    :value="item.uuid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="informationItem">
              <div class="two-row" style="width:100%">
                <div class="name">备注：</div>
                <el-input
                  v-model="printContent"
                  placeholder="请输入备注"
                ></el-input>
              </div>
            </div>
            <div class="informationItem">
              <div class="two-row two-row2">
                <div class="name">说明文件：</div>
                <el-upload
                  action="/service-center/upload/file/single"
                  :on-success="supportingPaperSuccess"
                  :on-remove="fileDelete"
                  class="hiddenInput"
                  :headers="headers"
                >
                  <el-button icon="el-icon-upload2">上传文件</el-button>
                <p class="kuzhan">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</p>

                </el-upload>
              </div>
            </div>
            <!-- <div class=" file-rows">
              <div class="file-row" v-for="(item, index) in fileList">
                <div class="name">{{ item.fileName }}</div>
                <el-button class="el-icon-close" type="text" @click="fileDelete(index)"
                  ></el-button>
              </div>
            </div> -->
           
          </div>
        </div>
      </div>
    </div>
    <div class="placeAnOrderButton">
      <el-button type="primary" @click="submitPlaceAnOrder" :disabled="isReadOnly">立即下单</el-button>
    </div>
    <!--选择服务商-->
    <facilitator-dialog
      ref="facilitatorDialogRef"
      @selectFacilitator="selectFacilitator"
    ></facilitator-dialog>
    <!--历史上传-->
    <history-upload
      ref="historyUploadRef"
      @historyToPrint="historyToPrint"
    ></history-upload>
    <!-- 3D预览 -->
    <three-d
      ref="threeBox"
      :innerVisible="innerVisible"
      :fileListNew="fileListNew"
      @closeDlog="closeDlog"
    ></three-d>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getDictionaryGroup,
  getManagerProvidersInfo,
  getModelLandDetail,
  savePrintOrder,
  findBuyerPrintOrderDetail,
  saveOrderPrint,
  getOrderPrint,
  getModelFileList,
  getAddressList,
  getLogisticsInfo,
  findTypeListByGroupUuid,
} from "../../utils/interface";
import facilitatorDialog from "./facilitatorDialog";
import historyUpload from "./historyUpload";
import threeD from "../threeD/index";
import { ModelStl, ModelObj } from "vue-3d-model";
import {mapMutations,mapState} from "vuex";

export default {
  name: "placeAnOrder",
  data() {
    return {
      modelFileList: [],
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      printNum: 1,
      technologyList: [],
      technologyUuid: "",
      props: {
        value: "uuid",
        label: "name",
      },
      materialUuid: "",
      materialList: [],
      soildUuid: false,
      isReprocess: false,
      reprocessList: [],
      printContent: "",
      fileList: [],
      typeUuid: "",
      surfaceEffectUuid: "",
      surfaceEffectList: [],
      facilitator: {},
      materialManagerUuid: "",
      form: {},
      minValue: "800",
      printOrderUuid: "",
      x1: "",
      x2: "",
      x3: "",
      y1: "",
      y2: "",
      y3: "",
      z1: "",
      z2: "",
      z3: "",
      loader: "",
      modelLand: "",
      //
      materialDensity: "",
      materialPrice: "",
      // 历史数据
      long: 0,
      width: 0,
      height: 0,
      scale: 0,
      volume: 0,
      unitPrice: 0,
      weight: 0,
      // 3D预览
      fileListNew: [],
      innerVisible: false,
      rotation: {
        // x: -Math.PI / 2,
        x: 200,
        y: 0,
        z: 100,
      },
      base64img:'',
      //
      province:"",
      city:"",
      district:"",
      addressInfo:"",
      // 只读
      isReadOnly:false,
      //
      modelUuid:"",
    };
  },
  components: {
    facilitatorDialog,
    historyUpload,
    threeD,
    ModelStl,
    ModelObj,
  },
  computed: {
    ...mapState({
        isLogin: "isLogin",
    }),
  },
  created() {
    this.getDictionary({ groupCode: "technology_print" });
    this.getMaterialDictionaryList();
    this.getReprocessList();
    this.printOrderUuid = window.sessionStorage.getItem("printOrderUuid");
    if (this.printOrderUuid == null) {
      let ret = {
        name: this.$route.query.fileName,
        url: this.$route.query.fileUrl,
        img: this.$route.query.img
          ? this.$route.query.img
          : require("@/assets/模型库/11笔筒.png"),
        isEdit: false,
      };
      this.modelFileList = [];
      this.technologyUuid = this.$route.query.technologyValue;
      this.materialUuid = this.$route.query.materialValue;
      this.soildUuid = this.$route.query.isHollow === "YES" ? true : false;
      this.isReprocess = this.$route.query.isReprocess === "YES" ? true : false;
      this.materialManagerUuid = this.$route.query.materialManagerUuid;
      this.modelUuid = this.$route.query.modelUuid;
      if(this.modelUuid!=undefined&&this.modelUuid!=null){
        // 查询模型文件
        getModelFileList({modelUuid:this.modelUuid}).then((res)=>{
          if(res.success){
            res.data.map(item=>{
              this.threeAnimal({name:item.name,url:item.url});
            });
          }
        });
      }
      // 根据选择的打印料查询服务商
      // 如果没有打印材料则不需要查询
      if (this.materialManagerUuid != "" && this.materialManagerUuid!=undefined) {
        getManagerProvidersInfo({
          materialManagerUuid: this.materialManagerUuid,
        }).then((res) => {
          this.facilitator = res.data;
          // 服务商id
          this.form.providersSettledUuid = this.facilitator.uuid;
          // 选择打印材料id
          this.form.materialManagerUuid = this.facilitator.managerList[0].uuid;
          // 材料密度
          this.materialDensity = this.facilitator.managerList[0].density;
          // 材料单价
          this.materialPrice = this.facilitator.managerList[0].unitPrice;
          // 计算长宽高
          this.threeAnimal(ret);
        });
      } else {
        this.facilitator = {};
        // 计算长宽高
        if(ret.url!=undefined) {
          this.threeAnimal(ret);
        }
      }
      this.getAddressList();
    } else {
      // 查询订单详情
      this.findOrderDetail();
    }
  },
  mounted(){
    if (this.isLogin == false) {
      this.$alert("请先登录", {
          confirmButtonText: "确定",
          callback: (action) => {
              this.$router.push('/login')
          },
      });
    }
  },
  methods: {
    getProviders(msg){
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: msg.enterPriseId },
      });
      window.open(routeData.href, "_blank");
    },
      // 获取默认地址
      getAddressList() {
        getAddressList().then((res) => {
          res.data.map(item => {
            if(this.form.takeOverUuid!=null){
              if (item.uuid == this.form.takeOverUuid) {
                // 获取默认地址
                this.form.takeOverUuid = item.uuid;
                this.getAddressInfo(item);
              }
            }else{
              if (item.defaultVal == 1) {
                // 获取默认地址
                this.form.takeOverUuid = item.uuid;
                this.getAddressInfo(item);
              }
            }
          });
        })
      },
    changeIsEdit(item) {
      if (
        this.long != 0 ||
        this.width != 0 ||
        this.height != 0 ||
        this.scale != 0 ||
        this.volume != 0 ||
        this.weight != 0
      ) {
        this.$message.error("请先保存其他修改后的数据!");
        return false;
      } else {
        item.isEdit = !item.isEdit;
        this.long = item.longSize;
        this.width = item.widthSize;
        this.height = item.heightSize;
        this.scale = item.scale;
        this.volume = item.volume;
        this.weight = item.weightModel;
      }
    },
    saveModelInfo(item) {
      item.isEdit = false;
      this.long = 0;
      this.width = 0;
      this.height = 0;
      this.scale = 0;
      this.volume = 0;
      this.weight = 0;
    },
    countModelInfo(item, index) {
      // 计算参数算出比例，然后根据比例计算最后值
      // 1,2,3,4 长度，宽度，高度，比例
      let ratio = 0;
      if (index == 1) {
        ratio = Number(item.longSize / this.long).toFixed(2);
      } else if (index == 2) {
        ratio = Number(item.widthSize / this.width).toFixed(2);
      } else if (index == 3) {
        ratio = Number(item.heightSize / this.height).toFixed(2);
      } else if (index == 4) {
        ratio = Number(item.scale / this.scale).toFixed(2);
      }
      if (ratio < 0.1) {
        ratio = 0.1;
      }
      item.longSize = Number(this.long * ratio).toFixed(2);
      item.widthSize = Number(this.width * ratio).toFixed(2);
      item.heightSize = Number(this.height * ratio).toFixed(2);
      item.volume = Number(this.volume * ratio * ratio * ratio).toFixed(2);
      item.unitPrice = (
        item.volume *
        this.materialDensity *
        this.materialPrice
      ).toFixed(2);
      item.weightModel = (item.volume * this.materialDensity).toFixed(2);
      item.scale = ratio * 100;
    },
    // 计算参数值
    recalculate() {
      if (this.modelFileList.length > 0) {
        this.modelFileList.map((item) => {
          item.unitPrice = Number(
            item.volume * this.materialDensity * this.materialPrice
          ).toFixed(2);
          // 计算重量
          item.weightModel = Number(item.volume * this.materialDensity).toFixed(
            2
          );
        });
      }
    },
    findOrderDetail() {
      let params = {
        uuid: this.printOrderUuid,
      };
      findBuyerPrintOrderDetail(params).then((res) => {
        this.form = res.data;
        this.technologyUuid = res.data.technologyUuid;
        this.materialUuid = [res.data.firstMaterialUuid, res.data.materialUuid];
        this.soildUuid = res.data.soildUuid === "YES" ? true : false;
        this.isReprocess = res.data.isReprocess === "YES" ? true : false;
        this.typeUuid = res.data.typeUuid;
        this.surfaceEffectUuid = res.data.surfaceEffectUuid;
        this.printContent = res.data.printContent;
        this.materialManagerUuid = res.data.materialManagerUuid;
        this.modelFileList = res.data.technologyList;
        this.fileList = res.data.fileList;
        this.findSurfaceEffect();
        this.getAddressList();
        if(this.materialManagerUuid!="") {
          getManagerProvidersInfo({
            materialManagerUuid: res.data.materialManagerUuid,
          }).then((res) => {
            this.facilitator = res.data;
            // 材料密度
            this.materialDensity = this.facilitator.managerList[0].density;
            // 材料单价
            this.materialPrice = this.facilitator.managerList[0].unitPrice;
          });
        }
      });
    },
    // 计算空心数据
    getModelLand() {
      let params = {
        materialManagerUuid: this.materialManagerUuid,
        minValue: this.minValue,
      };
      getModelLandDetail(params).then((res) => {
        if (res.success) {
          if (res && res.data.length > 0) {
            this.modelLand = res.data[0].modelLand;
          }
        }
      });
    },
    searchProvidersList() {
      // 服务商id
      this.form.providersSettledUuid = "";
      // 选择打印材料id
      this.form.materialManagerUuid = "";
      // 重新查询服务商列表集合
      this.facilitator = {};
      // 清空数据
      this.materialDensity = "";
      this.materialPrice = "";
      // 服务商选择后重新计算单价跟
      this.recalculate();
    },
    // 模型文件上传
    handleAvatarSuccess(res, file) {
      this.$message.success("上传成功！");
      // 计算长宽高
      this.threeAnimal(res);
    },
    threeAnimal(res) {
      let threeImgs = res.url;
      var w = 1000;
      var h = 396;

      var renderer;

      function initRender() {
        renderer = new THREE.WebGLRenderer({
          antialias: true,
        });
        renderer.setSize(w, h);
        //告诉渲染器需要阴影效果
        renderer.setClearColor(0xffffff);
      }

      var camera;

      function initCamera() {
        camera = new THREE.PerspectiveCamera(45, w / h, 0.1, 1000);
        camera.position.set(0, 40, 50);
        camera.lookAt(new THREE.Vector3(0, 0, 0));
      }

      var scene;

      function initScene() {
        scene = new THREE.Scene();
      }

      //初始化dat.GUI简化试验流程
      var gui;

      function initGui() {
        //声明一个保存需求修改的相关数据的对象
        gui = {};
        var datGui = new dat.GUI();
        //将设置属性添加到gui当中，gui.add(对象，属性，最小值，最大值）
      }

      var light;

      function initLight() {
        scene.add(new THREE.AmbientLight(0x444444));

        light = new THREE.PointLight(0xffffff);
        light.position.set(0, 50, 50);

        //告诉平行光需要开启阴影投射
        light.castShadow = true;

        scene.add(light);
      }
      let that = this;
      function initModel() {
        //文件路径
        //获取最后一个.的位置
        var index = threeImgs.lastIndexOf(".");
        //获取后缀
        var ext = threeImgs.substr(index + 1);
        //辅助工具
        // var helper = new THREE.AxesHelper(50);
        // scene.add(helper);
        // 上传文件
        if (ext.toUpperCase() == "STL") {
          that.loader = new THREE.STLLoader();
        } else if (ext.toUpperCase() == "OBJ") {
          that.loader = new THREE.OBJLoader();
        }
        that.loader.load(threeImgs, function (geometry) {
          if (ext.toUpperCase() == "OBJ") {
              if (geometry instanceof THREE.Group) {
            //   geometry = new THREE.Geometry().fromObject3D(geometry);
            }
              // console.log('1111',geometry);
            // //创建纹理
            var mat = new THREE.MeshLambertMaterial({
              color: 0x00ffff,
            });
            var mesh = new THREE.Mesh(geometry, mat);
            var boundingBox = new THREE.Box3().setFromObject(mesh).size();

            // 查看加载器生成的材质对象：MeshPhongMaterial
            let labelObj = geometry.children[0]
            let box = new THREE.BoxHelper(labelObj, 0xff0000)
            console.log('box',box);
            box.geometry.computeBoundingBox()
          //  console.log( '0-gg',geometry.children[0].geometry.computeBoundingBox());
          //   // console.log('box-max',box.geometry.boundingBox.max)
          //   console.log('box->child-x',box.object.geometry.boundingBox.max)
          //   console.log('box->child-x',box.object.geometry.boundingBox.max.length())

          //   console.log('2222', geometry.children[0].geometry);
          //   console.log('5555',geometry.children[0].geometry.boundingBox.max.y);
          //   console.log('3333',boundingBox );
            scene.add(geometry);
            // 加载后的一些编辑操作
            geometry.children[0].scale.set(5, 5, 5); //网格模型缩放
            geometry.children[0].geometry.center(); //网格模型的几何体居中
            // geometry.children[0].material.color.set(0x00ffff); //设置材质颜色

            if ((boundingBox.x / 10).toFixed(2) > 50) {
              mesh.scale.set(0.03, 0.03, 0.03); //缩放
            } else if ((boundingBox.x / 10).toFixed(2) < 10) {
              mesh.scale.set(0.5, 0.5, 0.5); //缩放
            }

            that.modelFileList.push({
              isEdit: false,
              longSize: 0,
              widthSize: 0,
              heightSize: 0,
              printNum: 1,
              unitPrice: 0,
              volume: 0,
              scale: "100",
              weightModel: 0,
              ...res,
            });
          } else if (ext.toUpperCase() == "STL") {
            if (geometry instanceof THREE.BufferGeometry) {
              geometry = new THREE.Geometry().fromBufferGeometry(geometry);
            }
            //尺寸
            geometry.computeBoundingBox();
            // 计算体积
            var volume = 0;
            for (var f = 0, fl = geometry.faces.length; f < fl; f++) {
              var face = geometry.faces[f];

              var vA = geometry.vertices[face.a];
              var vB = geometry.vertices[face.b];
              var vC = geometry.vertices[face.c];

              (that.x1 = vA.x), (that.x2 = vB.x), (that.x3 = vC.x);
              (that.y1 = vA.y), (that.y2 = vB.y), (that.y3 = vC.y);
              (that.z1 = vA.z), (that.z2 = vB.z), (that.z3 = vC.z);
              let V =
                (-that.x3 * that.y2 * that.z1 +
                  that.x2 * that.y3 * that.z1 +
                  that.x3 * that.y1 * that.z2 -
                  that.x1 * that.y3 * that.z2 -
                  that.x2 * that.y1 * that.z3 +
                  that.x1 * that.y2 * that.z3) /
                6;

              volume += V / 1000;
            }
            console.log("体积：", volume.toFixed(2) + "cm3");

            //创建纹理
            var mat = new THREE.MeshLambertMaterial({
              // color: 0x00ffff,
              color: 0x00ffff,
            });
            var mesh = new THREE.Mesh(geometry, mat);
            //console.log(mesh);

            mesh.rotation.x = -0.5 * Math.PI; //将模型摆正
            mesh.scale.set(0.5, 0.5, 0.5); //缩放
            geometry.center(); //居中显示
            scene.add(mesh);
            // 长宽高
            // 计算长宽高
            var boundingBox = new THREE.Box3().setFromObject(mesh).size();
            let lengthBox = ((boundingBox.x / 10) * 2).toFixed(2);
            let heightBox = ((boundingBox.y / 10) * 2).toFixed(2);
            let widthBox = ((boundingBox.z / 10) * 2).toFixed(2);
            console.log(
              "var box = new THREE.Box3().setFromObject( mesh );",
              new THREE.Box3().setFromObject(mesh).size()
            );
            // 空心查询脱壳厚度
            if (that.soildUuid) {
              that.minValue = Number(lengthBox);
              if (that.minValue > Number(widthBox)) {
                that.minValue = Number(widthBox);
                if (that.minValue > Number(heightBox)) {
                  that.minValue = Number(heightBox);
                }
              } else if (that.minValue > Number(heightBox)) {
                that.minValue = Number(heightBox);
                if (that.minValue > Number(widthBox)) {
                  that.minValue = Number(widthBox);
                }
              }
              that.getModelLand();
            }
            // 计算单价
            let unitPrice = 0;
            unitPrice =
              volume.toFixed(2) * that.materialDensity * that.materialPrice;
            // 计算重量
            let weightModel = 0;
            weightModel = volume.toFixed(2) * that.materialDensity;
            // 保存数据
            that.modelFileList.push({
              isEdit: false,
              longSize: lengthBox,
              widthSize: widthBox,
              heightSize: heightBox,
              printNum: 1,
              unitPrice: unitPrice.toFixed(2),
              volume: volume.toFixed(2),
              scale: "100",
              weightModel: weightModel,
              ...res,
            });
          }
        });
      }

      //初始化性能插件
      var stats;

      function initStats() {
        stats = new Stats();
      }

      //用户交互插件 鼠标左键按住旋转，右键按住平移，滚轮缩放
      var controls;

      function initControls() {
        controls = new THREE.OrbitControls(camera, renderer.domElement);

        // 如果使用animate方法时，将此函数删除
        //controls.addEventListener( 'change', render );
        // 使动画循环使用时阻尼或自转 意思是否有惯性
        controls.enableDamping = true;
        //动态阻尼系数 就是鼠标拖拽旋转灵敏度
        //controls.dampingFactor = 0.25;
        //是否可以缩放
        controls.enableZoom = true;
        //是否自动旋转
        controls.autoRotate = true;
        controls.autoRotateSpeed = 0.5;
        //设置相机距离原点的最远距离
        controls.minDistance = 1;
        //设置相机距离原点的最远距离
        controls.maxDistance = 200;
        //是否开启右键拖拽
        controls.enablePan = true;
      }

      function render() {
        renderer.render(scene, camera);
      }

      //窗口变动触发的函数
      function onWindowResize() {
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
        render();
        renderer.setSize(w, h);
      }

      function animate() {
        //更新控制器
        render();

        //更新性能插件
        stats.update();

        controls.update();

        requestAnimationFrame(animate);
      }

      function draw() {
        initGui();
        initRender();
        initScene();
        initCamera();
        initLight();
        initModel();
        initControls();
        initStats();
        animate();
        window.onresize = onWindowResize;
      }
      draw();
    },
    beforeAvatarUpload(file) {
      let fileType = "obj,OBJ,stl,STL";
      let fileName = file.name.lastIndexOf(".") + 1;
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      if (fileType.indexOf(fileTypeName) === -1) {
        this.$message.warning("请上传obj、stl格式模型文件");
        return false;
      } else {
        return true;
      }
    },
    // 模型文件删除
    modelDelete(index) {
      this.modelFileList.splice(index, 1);
    },
    // 获取字典值
    getDictionary(params) {
      getDictionaryItem(params).then((res) => {
        this.technologyList = res;
      });
    },
    getReprocessList() {
      getDictionaryGroup({ parentCode: "reprocess_type" }).then((res) => {
        this.reprocessList = res;
      });
    },
    findSurfaceEffect() {
      getDictionaryItem({ groupUuid: this.typeUuid }).then((res) => {
        if (res) {
          this.surfaceEffectList = res;
        }
      });
    },
    // 获取材料一二级分类
    getMaterialDictionaryList() {
      getDictionaryGroup({ parentCode: "material_print" }).then((res) => {
        res.map((item) => {
          findTypeListByGroupUuid({groupUuid:item.uuid}).then((res)=>{
            if(res){
              item.children = res.data;
            }
          })
        });
        this.materialList = res;
      });
    },
    // 上传说明文件
    supportingPaperSuccess(res, file) {
      this.$message.success("上传成功！");
      this.fileList.push({
        fileName: res.name,
        filePath: res.url,
      });
    },
  
  
    // 说明问价删除
    // fileDelete(index) {
    //   this.fileList.splice(index, 1);
    // },
    fileDelete(file, fileList) {
      this.fileList = fileList
      console.log('this.fileList',this.fileList);
    },
    // 选择服务商
    toSelectFacilitator() {
        if(this.technologyUuid!=undefined&&this.technologyUuid!=""
            &&this.materialUuid!=undefined&&this.materialUuid!=""){
          this.$refs.facilitatorDialogRef.init(
                  this.technologyUuid,
                  this.materialUuid,
                  this.soildUuid,
                  this.isReprocess
          );
        }else{
          this.$message.error("请选择打印工艺或者打印材料");
        }
    },
    // 选择服务商
    selectFacilitator(val) {
      this.facilitator = val;
      // 服务商id
      this.form.providersSettledUuid = val.uuid;
      // 选择材料id
      this.form.materialManagerUuid = val.managerList[0].uuid;
      // 材料密度
      this.materialDensity = val.managerList[0].density;
      // 材料单价
      this.materialPrice = val.managerList[0].unitPrice;
      // 服务商选择后重新计算单价跟
      this.recalculate();
    },
    // 确认下单
    submitPlaceAnOrder() {
      if (this.modelFileList.length <= 0) {
        this.$message.warning("请上传模型文件!");
      } else if (!this.facilitator.uuid) {
        this.$message.warning("请选择服务商!");
      } else if (!this.technologyUuid) {
        this.$message.warning("请选择打印工艺!");
      } else if (!this.materialUuid) {
        this.$message.warning("请选择打印材料!");
      } else if (this.isReprocess) {
        if (!this.typeUuid) {
          this.$message.warning("请选择后处理类型!");
        } else if (!this.surfaceEffectUuid) {
          this.$message.warning("请选择后处理效果!");
        } else {
          this.saveInfo();
        }
      } else {
        this.saveInfo();
      }
    },
    getAddressInfo(item){
      // 省市县
      if(item.province!=''&&item.province!=item.city){
        this.province = item.province.replace('省','');
        this.addressInfo += "," + item.province.replace('省','');
      }else if(item.province!=''&&item.province==item.city){
        this.province = item.province.replace('市','');
        this.addressInfo += "," + item.province.replace('市','');
      }
      if(item.city!=''&&item.province!=item.city){
        this.city = this.province + "," + item.city.replace('市','');
        this.addressInfo += "," + item.city.replace('市','');
      }
      if(item.district!=''){
        this.district = item.district;
        this.addressInfo += "," + item.district;
      }
      this.addressInfo = this.addressInfo.substring(1);
    },
    saveInfo() {
      this.isReadOnly = true;
      this.form.technologyList = this.modelFileList;
      this.form.technologyUuid = this.technologyUuid;
      this.form.firstMaterialUuid = this.materialUuid[0];
      this.form.materialUuid = this.materialUuid[1];
      this.form.soildUuid = this.soildUuid == true ? "YES" : "NO";
      this.form.isReprocess = this.isReprocess == true ? "YES" : "NO";
      this.form.typeUuid = this.typeUuid;
      this.form.surfaceEffectUuid = this.surfaceEffectUuid;
      this.form.printContent = this.printContent;
      this.form.fileList = this.fileList;
      this.form.orderStatus = "UN_CONFIRM";
      this.form.payStatus = "UN_PAY";
      this.form.goodsNum = 0;
      this.form.totalPrice = 0;
      this.form.weightModel = 0;
      this.form.transportationPrice = 0;
      // 商品数量
      if (this.modelFileList.length > 0) {
        this.modelFileList.map((item) => {
          this.form.weightModel =
            Number(this.form.weightModel) + Number(item.weightModel);
          this.form.goodsNum =
            Number(this.form.goodsNum) + Number(item.printNum);
          this.form.totalPrice = Number(this.form.totalPrice)+Number(Number(item.unitPrice)*Number(item.printNum));
        });
      }
      // 计算邮费
      if(this.facilitator.managerList[0].isTransportation=="YES") {
        let logisticsUuid = this.facilitator.managerList[0].logisticsUuid;
        getLogisticsInfo({uuid:logisticsUuid}).then((res)=>{
          let isFlag = true;
          if(res.success){
            // 先判断当前区域是否存在免费区域内
            if(res.data.freeArea=="全国"){
              this.form.transportationPrice = 0;
            }else if(res.data.freeArea.indexOf(this.province)!=-1) {
              this.form.transportationPrice = 0;
              // 市
              if (res.data.freeArea.indexOf(this.city) != -1) {
                // 如果省市存在，省市县不存在则按照省市来算。
                this.form.transportationPrice = 0;
                // 区域
                if (res.data.freeArea.indexOf(this.district) != -1) {
                  isFlag = false;
                  this.form.transportationPrice = 0;
                }else{
                  this.form.transportationPrice = 0;
                }
              }
            }
            // 按件
            if(isFlag) {
              let itemList = res.data.details;
              if (res.data.chargeMode == "piece") {
                if(this.form.totalPrice==0){
                  this.form.totalPrice = Number(this.form.totalPrice) + Number(this.form.transportationPrice);
                }else {
                  if (itemList.length > 0) {
                    for (let i = 0; i < itemList.length; i++) {
                      // 如果是全国直接计算
                      if (itemList[i].area.indexOf("全国") != -1) {
                        if (this.form.goodsNum > itemList[i].firstHeavy) {
                          // 首件是默认的运费
                          this.form.transportationPrice = itemList[i].freight;
                          // 续件运费
                          let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                          this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                        } else {
                          this.form.transportationPrice = itemList[i].freight;
                        }
                      } else if (itemList[i].area.indexOf(this.province) != -1) {
                        // 如果省市存在，省市县不存在则按照省市来算。
                        if (this.form.goodsNum > itemList[i].firstHeavy) {
                          // 首件是默认的运费
                          this.form.transportationPrice = itemList[i].freight;
                          // 续件运费
                          let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                          this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                        } else {
                          this.form.transportationPrice = itemList[i].freight;
                        }
                        // 市
                        if (itemList[i].area.indexOf(this.city) != -1) {
                          if (this.form.goodsNum > itemList[i].firstHeavy) {
                            // 首件是默认的运费
                            this.form.transportationPrice = itemList[i].freight;
                            // 续件运费
                            let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                            this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                          } else {
                            this.form.transportationPrice = itemList[i].freight;
                          }
                          // 区域
                          if (itemList[i].area.indexOf(this.district) != -1) {
                            // 省市县都存在，就按照省市县来算
                            // 如果省市存在，省市县不存在则按照省市来算。
                            if (this.form.goodsNum > itemList[i].firstHeavy) {
                              // 首件是默认的运费
                              this.form.transportationPrice = itemList[i].freight;
                              // 续件运费
                              let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                              this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                            } else {
                              this.form.transportationPrice = itemList[i].freight;
                            }
                            break;
                          } else {
                            // 如果省市存在，省市县不存在则按照省市来算。
                            if (this.form.goodsNum > itemList[i].firstHeavy) {
                              // 首件是默认的运费
                              this.form.transportationPrice = itemList[i].freight;
                              // 续件运费
                              let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                              this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                            } else {
                              this.form.transportationPrice = itemList[i].freight;
                            }
                          }
                          break;
                        }
                      }
                    }
                    this.sumPrice = Number(this.sumPrice).toFixed(2);
                    this.form.totalPrice = Number(this.form.totalPrice) + Number(this.form.transportationPrice);
                  }
                }
              } else if (res.data.chargeMode == "weight") {
                // 重量计算
                if(this.form.weightModel==0){
                  this.form.transportationPrice = 0;
                  this.form.totalPrice = Number(this.form.totalPrice) + Number(this.form.transportationPrice);
                }else {
                  if (itemList.length > 0) {
                    for (let i = 0; i < itemList.length; i++) {
                      if (itemList[i].area.indexOf("全国") != -1) {
                        if (this.sumWeight > itemList[i].firstHeavy) {
                          // 首件是默认的运费
                          this.form.transportationPrice = itemList[i].freight;
                          // 续件运费
                          let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                          this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                        } else {
                          this.form.transportationPrice = itemList[i].freight;
                        }
                      } else if (itemList[i].area.indexOf(this.province) != -1) {
                        if (this.sumWeight > itemList[i].firstHeavy) {
                          // 首件是默认的运费
                          this.form.transportationPrice = itemList[i].freight;
                          // 续件运费
                          let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                          this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                        } else {
                          this.form.transportationPrice = itemList[i].freight;
                        }
                        if (itemList[i].area.indexOf(this.city) != -1) {
                          if (this.sumWeight > itemList[i].firstHeavy) {
                            // 首件是默认的运费
                            this.form.transportationPrice = itemList[i].freight;
                            // 续件运费
                            let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                            this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                          } else {
                            this.form.transportationPrice = itemList[i].freight;
                          }
                          if (itemList[i].area.indexOf(this.district) != -1) {
                            if (this.sumWeight > itemList[i].firstHeavy) {
                              // 首件是默认的运费
                              this.form.transportationPrice = itemList[i].freight;
                              // 续件运费
                              let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                              this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                            } else {
                              this.form.transportationPrice = itemList[i].freight;
                            }
                            break;
                          } else {
                            if (this.sumWeight > itemList[i].firstHeavy) {
                              // 首件是默认的运费
                              this.form.transportationPrice = itemList[i].freight;
                              // 续件运费
                              let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                              this.form.transportationPrice = this.form.transportationPrice + Number(num * itemList[i].renew);
                            } else {
                              this.form.transportationPrice = itemList[i].freight;
                            }
                          }
                          break;
                        }
                      }
                    }
                    this.form.transportationPrice = 0;
                    this.form.totalPrice = Number(this.form.totalPrice) + Number(this.form.transportationPrice);
                  }
                }
              }
            }
          }
        });
      }else{
        this.form.transportationPrice = 0;
        this.form.totalPrice = Number(this.form.totalPrice) + Number(this.form.transportationPrice);
      }
      savePrintOrder(this.form).then((res) => {
          if(res.success) {
              this.isReadOnly = false;
              this.$message.success("保存成功!");
              // 移除数据
              this.$cookies.remove("modelPrintFileList");
              window.sessionStorage.setItem(
                  "printOrderUuid",
                  res.data.uuid
              );
              this.$router.push({
                  name: "printAffirmOrder",
                  params: {printOrderUuid: res.data.uuid},
              });
          }
      });
      /*savePrintOrder(this.form).then((res) => {
        if (res.success) {
          this.form.uuid = res.data.uuid;
          // 先查询是否存在参数，如果存在则修改，如果不存在则新增
          getOrderPrint({ printOrderUuid: res.data.uuid }).then((result) => {
            let params = {};
            if (result != "") {
              result.totalNum = this.form.goodsNum;
              params = result;
            } else {
              params = {
                printOrderUuid: res.data.uuid,
                totalNum: this.form.goodsNum,
                totalPrice: this.form.totalPrice,
              };
            }
            saveOrderPrint(params).then((rest) => {
              if (rest.success) {
                this.form.orderCode = rest.data.orderNo;
                // 保存成功
                savePrintOrder(this.form).then((resl) => {
                  this.$message.success("保存成功!");
                  window.sessionStorage.setItem(
                    "printOrderUuid",
                    resl.data.uuid
                  );
                  this.$router.push({
                    name: "printAffirmOrder",
                    params: { printOrderUuid: res.data.uuid },
                  });
                });
              }
            });
          });
        }
      });*/
    },
    // 历史上传
    historyUploadSelect() {
      this.$refs.historyUploadRef.init();
    },
    // 历史上传打印
    historyToPrint(val) {
      console.log(val);
      // 计算单价
      let unitPrice = 0;
      unitPrice = val.volume * this.materialDensity * this.materialPrice;
      // 计算重量
      let weightModel = 0;
      weightModel = val.volume * this.materialDensity;
      this.modelFileList.push({
        isEdit: false,
        longSize: val.longSize,
        widthSize: val.widthSize,
        heightSize: val.heightSize,
        printNum: 1,
        unitPrice: unitPrice.toFixed(2),
        volume: val.volume,
        scale: val.scale,
        weightModel: weightModel,
        name: val.name,
        url: val.url
      });
    },
    // 服务商编辑
    facilitatorEdit() {
      this.$refs.facilitatorDialogRef.init(
        this.technologyUuid,
        this.materialUuid,
        this.soildUuid,
        this.isReprocess
      );
    },
    // 预览3D模型
    previewThreeD(item) {
      console.log(item);
      this.$refs.threeBox.threeAnimal(item);
      this.innerVisible = true;
    },
    closeDlog(index) {
      this.innerVisible = index;
    },
  },
};
</script>

<style scoped lang="less">
div {
  box-sizing: border-box;
}

.placeAnOrderBox {
  background: #f0f2f5;
  padding: 90px 0 100px;

  .modelExhibition {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 2px;

    .title {
      width: 100%;
      height: 56px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;

      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }

      .titleRight {
        display: flex;

        button {
          margin-left: 50px;
        }
      }
    }

    .modelFileList {
      padding: 24px;

      .modelFileItem {
        background: #f8f8f8;
        border-radius: 10px;
        padding: 24px;
        display: flex;
        position: relative;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .itemLeft {
          width: 96px;
          height: 96px;
          position: relative;
          &:hover {
            .model {
              display: block;
            }
          }
          img {
            width: 96px;
            height: 96px;
            border: 1px solid rgba(0, 0, 0, 0.15);
          }
          .model {
            position: absolute;
            left: 0;
            top: 0;
            width: 98px;
            height: 98px;
            background: rgba(0, 0, 0, 0.3);
            text-align: center;
            line-height: 94px;
            display: none;
            i {
              color: #fff;
              cursor: pointer;
              font-size: 20px;
            }
          }
        }

        .itemRight {
          padding-left: 20px;
          width: 100%;

          .modelInfo {
            font-size: 14px;
            border-bottom: 1px dashed #e8e8e8;
            padding-bottom: 20px;

            .name {
              font-weight: 500;
              color: #000000;
            }

            .size {
              font-weight: 400;
              color: #666666;
              padding-top: 10px;
              position: relative;

              span {
                padding-right: 30px;
              }

              .modelEdit {
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }

            .operation {
              position: absolute;
              right: 24px;
              top: 10px;

              button {
                padding: 0;
              }
            }
          }

          .modelCount {
            display: flex;
            font-size: 14px;
            align-items: center;
            padding-top: 20px;
            color: #333333;

            .num {
              padding-right: 100px;
            }

            .price {
              span {
                color: #e20000;
              }
            }
          }
        }
      }
    }
  }

  .typeInformation {
    width: 1200px;
    margin: 30px auto;
    background: #fff;
    border-radius: 2px;

    .title {
      width: 100%;
      height: 56px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;

      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .typeInformationContent {
      padding: 24px;

      .facilitatorBox {
        background: #f8f8f8;
        border-radius: 10px;
        padding: 24px;
        display: flex;
        position: relative;
        margin-bottom: 16px;
        align-items: center;
        justify-content: space-between;

        .facilitatorBoxLeft {
          display: flex;
          align-items: center;
          width: 45%;
          font-size: 14px;
          color: #333;
          cursor: pointer;

          .logo {
            width: 190px;
            height: 90px;
            margin-right: 20px;

            img {
              width: 190px;
              height: 90px;
              border: 1px solid rgba(0, 0, 0, 0.15);
            }
          }
        }

        .facilitatorBoxRight {
          display: flex;
          align-items: center;
          width: 55%;
          justify-content: space-between;
          font-size: 14px;
          color: rgba(51, 51, 51, 0.75);
          padding-left: 20px;
        }
      }
    .tipItems{
        margin-left: 100px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .file_name{
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .re_show_file_list{
          margin-bottom: 20px;
        }
        .el-icon-document:before{
          margin-right: 20px;
        }
      }
       .file-rows {
        // display: flex;
        margin-bottom: 30px;
        margin-left: 98px;
        // flex-wrap: wrap;
        /deep/.el-upload--text{
          display: flex;
          align-items: center;
        }
        .one-row {
          width: 33%;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;

          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
          }
        }
        .two-row {
          width: 50%;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
           
          }
         
        }
      
       .two-rows {
          width: 50%;
          display: flex;
          font-size: 14px;
          color: #333;
         
          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
            line-height: 27px;
           
          }
         
        }
        
        p {
          font-size: 12px;
          color: #666666;
          padding-left: 10px;
        }
        .file-row {
          width: 40%;
          border: 1px solid #ddd;
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          font-size: 14px;
          position: relative;
          margin-right: 10%;
          margin-bottom: 16px;
          .el-icon-document:before{
            margin-right: 10px;
          }
          .el-icon-close:before{
            // background: #409EFF;
            border-radius: 50%;
          }
          .name {
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          button {
            position: absolute;
            right: 20px;
            top: 6px;
          }
        }
      }
      .informationItem {
        display: flex;
        margin-bottom: 30px;
        flex-wrap: wrap;
        /deep/.el-upload--text{
          display: flex;
          align-items: center;
        }
        .one-row {
          width: 33%;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;

          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
          }
        }
        .two-row {
          width: 50%;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
           
          }
         
        }
        .two-row2 {
          align-items: flex-start;
          .name,.kuzhan {
            margin-top: 10px;
          }
        }
      
       .two-rows {
          width: 50%;
          display: flex;
          font-size: 14px;
          color: #333;
         
          .name {
            min-width: 100px;
            text-align: right;
            padding-right: 15px;
            line-height: 27px;
           
          }
         
        }
        
        p {
          font-size: 12px;
          color: #666666;
          padding-left: 10px;
        }
        .file-row {
          width: 40%;
          border: 1px solid #ddd;
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          font-size: 14px;
          position: relative;
          margin-right: 10%;
          margin-bottom: 16px;
          .name {
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          button {
            position: absolute;
            right: 20px;
            top: 6px;
          }
        }
      }
    }
  }
  .placeAnOrderButton {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/print/placeAnOrder.vue